import { engagementsString, dynamicFacetNameEnabled } from './adapters';
import categoryPageAttributes from '../../category-page-attributes';
import { DataLayer } from '@core-ui/app-state-provider/types';
import { AppProps } from 'src/app/App';
import { FacetData, ModelToggle } from './types';

export const facetEngagementDatalayerEvent = (
  datalayer: DataLayer,
  queryString: string,
  props: AppProps,
  facetData: FacetData,
  isDynamicStyleFacetNameEnabled: boolean,
  appliedQuickFacets: string[],
  modelToggleData: ModelToggle
) => {
  const { webHierarchy, selectedNodes } = props;
  try {
    datalayer.link({
      event_name: 'refinement',
      ...categoryPageAttributes(props),
      facet_engagement: engagementsString({
        queryString,
        facetData,
        appliedQuickFacets,
        modelToggleData,
      }),
      test_coe: dynamicFacetNameEnabled(
        facetData,
        webHierarchy,
        selectedNodes,
        isDynamicStyleFacetNameEnabled
      ),
    });
  } catch (err) {
    datalayer.link({
      business_unit_id: props.businessUnitId,
      error_message: `[Facet Engagement Data Layer]: error: ${err.message}`,
    });
  }
};
